<template>
    <ActivityDetailsCard
        activityType="Evasion"
        :title="item.description"
        :entity="item.entity"
        class="pledged-shares-activity-details"
    >
        <template #sub-header>
            <div class="cell wide">
                <h5>Event</h5>
                <span>{{ transcript?.eventTitle }}</span>
            </div>
            <div class="cell wide">
                <h5>Company</h5>
                <span>{{ company?.name }}</span>
            </div>
            <div class="cell">
                <h5>Ticker</h5>
                <span>{{ company?.symbol }}</span>
            </div>
            <div class="cell">
                <h5>Date</h5>
                <span>{{ new Date(transcript?.eventDate).toLocaleDateString() }}</span>
            </div>
            <div class="cell">
                <h5>Evasive %</h5>
                <span>{{ percent(transcript?.evasion?.evasivePercentage) }}</span>
            </div>
            <div class="cell">
                <h5>Historical Avg.</h5>
                <span>{{ percent(transcript?.evasion?.historicalAverageEvasivePercentage) }}</span>
            </div>
            <div class="cell wide formatted" v-if="transcript?.evasion?.outlier">
                <OutlierIndicatorText :transcript="transcript" v-if="transcript" />
            </div>
        </template>

        <ProfileSection title="Evasion History">
            <EvasionChart
                :companyId="company.id"
                :transcripts="previous"
                :endDate="endDate"
                v-if="previous.length > 0"
            />
            <template #view-all>
                <router-link
                    class="primary"
                    :to="{
                        name: 'company-page',
                        params: { id: company.id },
                        query: { tab: 'Evasion', transcriptId: transcript.id },
                    }"
                >
                    View All Company Evasion
                </router-link>
            </template>
        </ProfileSection>

        <ActivityStockPriceLine :item="item" />
    </ActivityDetailsCard>
</template>

<script setup>
import ActivityStockPriceLine from '@/components/activity/ActivityStockPriceLine'
import ActivityDetailsCard from '@/components/activity/ActivityDetailsCard.vue'

import { formatNegativeParens } from '@/utils/format'
import { computed } from 'vue'
import OutlierIndicatorText from '../evasion/OutlierIndicatorText.vue'
import EvasionChart from '@/pages/CompanyPage/EvasionTab/EvasionChart.vue'
import { addDays } from '@/utils/date'
import ProfileSection from '../shared/profile-section.vue'

const props = defineProps({
    item: {
        type: Object,
        required: true,
    },
})

function percent(value) {
    if (value === undefined || value === null) {
        return 'N/A'
    }

    return formatNegativeParens(value, { style: 'percent', maximumFractionDigits: 0 })
}

const company = computed(() => props.item.details?.company ?? null)
const transcript = computed(() => props.item.details?.transcript ?? null)
const previous = computed(() => props.item.details?.previous ?? [])

const endDate = computed(() => {
    let date = new Date()

    if (!transcript.value) {
        return date
    }

    const ninetyAfterTranscript = addDays(90, new Date(transcript.value.eventDate))

    return ninetyAfterTranscript > date ? date : ninetyAfterTranscript
})
</script>
<style scoped>
.profile-section + .profile-section {
    margin-top: 40px;
}

.evasion-chart {
    height: 400px;
    width: 100%;
}
</style>
